import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from 'ressources/labels/de.json';
import en from 'ressources/labels/en.json';
import it from 'ressources/labels/it.json';
import zh from 'ressources/labels/zh.json';
import el from 'ressources/labels/el.json';
import es from 'ressources/labels/es.json';
import fr from 'ressources/labels/fr.json';
import jp from 'ressources/labels/jp.json';
import bg from 'ressources/labels/bg.json';

i18n
    .use(initReactI18next) // Passes i18n down to react-i18next
    .init({
        resources: {
            en: {
                translation: en,
            },
            de: {
                translation: de,
            },
            it: {
                translation: it,
            },
            zh: {
                translation: zh,
            },
            el: {
                translation: el,
            },
            es: {
                translation: es,
            },
            fr: {
                translation: fr,
            },
            jp: {
                translation: jp,
            },
            bg: {
                translation: bg,
            }
        },
        lng: 'en', // If you want to use language detection, consider using i18next-browser-languagedetector
        fallbackLng: 'en', // Use 'en' if the current language translations are missing
        interpolation: {
            escapeValue: false, // React already safely escapes values
        },
    });

export default i18n;